var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "arrow-right_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#arrow-right_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M8.873 17.127a.717.717 0 0 1-.217-.527c0-.206.072-.382.217-.527L12.946 12 8.873 7.927a.717.717 0 0 1-.217-.527c0-.206.072-.382.217-.527a.717.717 0 0 1 .527-.217c.206 0 .382.072.527.217l4.494 4.494a.83.83 0 0 1 .256.633.83.83 0 0 1-.256.633l-4.494 4.494a.717.717 0 0 1-.527.217.717.717 0 0 1-.527-.217Z",
    fill: "currentColor"
  }))));
};
export default SvgArrowRight;